let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7uTpi")).then(() => parcelRequire('jEGkU'));